import { Box, IconButton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  PageBar,
  SSPCommonTable,
  SSPCommonButton,
  SSPCommonVideo,
} from "../../../CommonComponents";
import { Download } from "@mui/icons-material";
import AWS from "aws-sdk";
import { functionURLService } from "../../../Components/functionalurl";
import SSPCommonModal from "../../../CommonComponents/SSPCommonModal/SSPCommonModal";
import * as FileSaver from "file-saver";
import Tooltip from "@mui/material/Tooltip";
import { useParams } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
  Grid,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import axios from "axios"; // Import axios for making HTTP requests
import { post } from "../../../services";
import Cookies from "js-cookie";
const base = "https://";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

const ViewInvoice = ({}) => {
  const id = Cookies.get("ssp_id");

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");

  const ExcelJS = require("exceljs");
  // to download customer master

  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };

  const [rows, setRows] = useState([]);

  const rowFetch = async () => {
    setmessage("Fetching Data");
    let response = await post(
      base +
        "bf7n2zcpvjgljiduwdqhzdvhtm0bwxcf.lambda-url.ap-south-1.on.aws/view_grn_summary",
      {},
      true,
      false
    );
    if (response.data !== null) {
      const rowsData = response.data.map((row, index) => ({
        ...row,
        id: index + 1,
      }));
      setRows(rowsData);
    } else {
      setmessage("No Rows");
      setmodalOpener(true);
    }
  };
  useEffect(() => {
    rowFetch();
  }, []);

  const columns = [
    { field: "invoice_no", headerName: "Invoice.no", flex: 1 },
    {
      field: "order_no",
      headerName: "PO No.",
      flex: 1,
      wrapText: true,
    },
    {
      field: "grn_number",
      headerName: "GRN No",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "po_value",
      headerName: "PO Value",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "grn_value",
      headerName: "GRN Value",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "grn_date",
      headerName: "GRN Date",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "approval_status",
      headerName: "Approval Status",
      headerClassName: 'wrap-header',
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "approval_remarks",
      headerName: "Approval Remark",
      headerClassName: 'wrap-header',
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "voucher_no",
      headerName: "Voucher No",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "invoice_url",
      headerName: "Download Invoice",
      type: "number",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          disabled={loading || params.row.status === "Error"}
          onClick={() => downloadInvoiceFile(params.row.invoice_url)}
        >
          <Download
            color={params.row.status === "Error" ? "grey" : "primary"}
          />
        </IconButton>
      ),
    },
    {
      field: "grn_url",
      headerName: "Download GRN",
      type: "number",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          disabled={loading || params.row.status === "Error"}
          onClick={() => downloadPOpdf(params.row.grn_url)}
        >
          <Download
            color={params.row.status === "Error" ? "grey" : "primary"}
          />
        </IconButton>
      ),
    },
  ];

  const downloadInvoiceFile = async (url) => {
    try {
      // Step 1: Get the presigned URL from the server
      let presignedUrlResponse = await post(
        base +
          "3jmp6lshmsni27vr65duh2l2je0unghx.lambda-url.ap-south-1.on.aws/get_url",
        {
          filename: url,
        },
        true,
        false
      );
      const presignedUrl = presignedUrlResponse.data.url;
      if (!presignedUrl) {
        console.error("Error: Empty presigned URL");
        return;
      }
      // Step 2: Use the presigned URL to download the file
      window.open(presignedUrl, "_blank");
    } catch (error) {
      console.error("Error during file download:", error);
    }
  };
  const downloadPOpdf = async (url) => {
    try {
      // Step 1: Get the presigned URL from the server
      let presignedUrlResponse = await post(
        base +
          "3jmp6lshmsni27vr65duh2l2je0unghx.lambda-url.ap-south-1.on.aws/get_url",
        {
          filename: url,
        },
        true,
        false
      );
      const presignedUrl = presignedUrlResponse.data.url;
      if (!presignedUrl) {
        console.error("Error: Empty presigned URL");
        return;
      }
      // Step 2: Use the presigned URL to download the file
      window.open(presignedUrl, "_blank");
    } catch (error) {
      console.error("Error during file download:", error);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EEF2F7",
      }}
    >
      {/* Page Bar */}
      <PageBar text="Fusion -> GRN" />

      <Card
        sx={{
          backgroundColor: "#EEF2F7",
          padding: "1.3rem",
        }}
      >
        <CardHeader
          p={2}
          sx={{
            backgroundColor: "#F8F8F9",
            fontWeight: "700",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          }}
          title={"GRN Summary"}
          titleTypographyProps={{
            sx: {
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "16px",
              color: "#0160F1",
            },
          }}
          action={
            <>
              <Button onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
            </>
          }
        />
        <Divider />
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
          }}
        >
          <Box
            sx={{
              display: { lg: "flex" },
            }}
          ></Box>
          <div>
            <div style={{ height: 700, width: "100%" }}>
              <DataGrid
                // disableColumnMenu={true}
                rowHeight={80}
                showCellRightBorder={true}
                sx={{
                  ".MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold !important",
                  },
                  overflowX: "scroll",
                }}
                rows={rows}
                columns={columns}
                headerClassName="header-center"
                rowsPerPageOptions={[10]}
                pageSize={10}
                getRowId={(row) => row.id}
                components={{
                  Toolbar: GridToolbar,
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </div>
          </div>
        </CardContent>
      </Card>
      {/* Video  */}
      {/* <SSPCommonVideo
        headerText={"Demo Video"}
        videoUrl={"https://www.youtube.com/embed/OXOuPx2DErA?si=Vx8VM0qBMCzb4NnV"}
      /> */}
      {modalOpener && (
        <SSPCommonModal
          open={modalOpener}
          handleOpenClose={setmodalOpener}
          message={message}
        />
      )}
    </Box>
  );
};

export default ViewInvoice;
